import React, { useEffect } from 'react';
import { useTheme } from '../../../context/ThemeContext';
import './LandingPage.css';



const LandingPage = ({ onNavigate }) => {
    const { identity, switchIdentity } = useTheme();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.shiftKey && e.key.toLowerCase() === 'w') {
                onNavigate?.('instructions');
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onNavigate]);

    const isAdmin = identity === 'admin';

    return (
        <div className={`stitch-container ${isAdmin ? 'mode-admin' : 'mode-teacher'}`}>

            <div className="bg-layer">
                <div className="aurora aurora-1"></div>
                <div className="aurora aurora-2"></div>
                <div className="aurora aurora-3"></div>
            </div>
            <div className="noise-overlay"></div>

            {/* FIX: added header-nav-inner wrapper so the nav has proper layout;
                added brand-lockup and header-cta-group which were fully styled
                in CSS but never rendered in JSX */}
            <nav className="header-nav">
                <div className="header-nav-inner">
                    <div className="brand-lockup" onClick={() => onNavigate('landing')} style={{ cursor: 'pointer' }}>
                        <img src="/Landscape_Logo.png" alt="EduSync Logo" className="brand-logo" />
                    </div>

                    <div className="mode-switcher">
                        <button
                            className={`switch-btn ${!isAdmin ? 'active' : ''}`}
                            onClick={() => switchIdentity('teacher')}
                        >
                            Teacher View
                        </button>
                        <button
                            className={`switch-btn ${isAdmin ? 'active' : ''}`}
                            onClick={() => switchIdentity('admin')}
                        >
                            Admin View
                        </button>
                    </div>

                    <div className="header-cta-group">
                        <button className="header-cta-link" onClick={() => onNavigate('instructions')}>
                            How it Works
                        </button>
                        <button className="header-cta-btn" onClick={() => onNavigate('login')}>
                            <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>login</span>
                            {isAdmin ? 'Admin Login' : 'Log In'}
                        </button>
                    </div>
                </div>
            </nav>

            <main className="main-content">
                {isAdmin ? <AdminView onNavigate={onNavigate} /> : <TeacherView onNavigate={onNavigate} />}
            </main>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-brand">
                        <img src="/Landscape_Icon.png" alt="EduSync Icon" className="footer-logo" />
                        <p className="footer-text">© 2026 EduSync. All rights reserved.</p>
                    </div>
                    <div className="footer-links">
                        <button className="footer-link" onClick={() => onNavigate('privacy-policy')}>Privacy Policy</button>
                        <button className="footer-link" onClick={() => onNavigate('terms-of-service')}>Terms of Service</button>
                        <button className="footer-link" onClick={() => onNavigate('instructions')}>How it Works</button>
                    </div>
                </div>
            </footer>
        </div>
    );
};

/* ─────────────────────────────────────────────
   TEACHER VIEW
───────────────────────────────────────────── */
const TeacherView = ({ onNavigate }) => (
    <div className="slide-up">
        <section className="hero">
            <div className="hero-left">
                <span className="eyebrow">
                    
                    For Teachers
                </span>
                <h1 className="hero-title">Teach Better,<br />Stress Less.</h1>
                <p className="hero-text">
                    Everything you need to manage your classroom in one place. Take attendance,
                    track student progress, and organize your daily lessons with ease.
                </p>
                <div className="hero-actions">
                    <button className="btn btn-primary" onClick={() => onNavigate('login')}>
                        Log In
                    </button>
                </div>
            </div>
            <div className="hero-right">
                <div className="stat-card">
                    <span className="stat-label">Daily Attendance</span>
                    <span className="stat-value">98%</span>
                    <div className="progress-track">
                        <div className="progress-bar" style={{ width: '98%' }}></div>
                    </div>
                </div>
                <div className="stat-card">
                    <span className="stat-label">Active Classes</span>
                    <span className="stat-value">12</span>
                    <div className="progress-track">
                        <div className="progress-bar" style={{ width: '60%' }}></div>
                    </div>
                </div>
            </div>
        </section>

        <section className="bento-grid">

            {/* Smart Attendance — col 8 */}
            <div className="b-card col-8">
                <div className="card-header">
                    <div>
                        <h2 className="card-title">Smart Attendance</h2>
                        <p className="card-subtitle">Quickly track who is in your class today</p>
                    </div>
                    <span className="material-symbols-outlined" style={{ color: 'var(--accent)', fontSize: '1.75rem' }}>qr_code_2</span>
                </div>
                <div style={{ flex: 1, display: 'flex', gap: '2rem', alignItems: 'center' }}>
                    <div style={{
                        width: '110px', height: '110px',
                        border: '1px solid var(--panel-border)',
                        borderRadius: '12px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: 'rgba(255,255,255,0.02)'
                    }}>
                        <span className="material-symbols-outlined" style={{ fontSize: '2.2rem', color: 'var(--accent)', opacity: 0.5 }}>hub</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.875rem', flex: 1 }}>
                        {['Classroom A', 'Classroom B', 'Science Lab', 'Library'].map((node, i) => (
                            <div key={i} style={{
                                padding: '0.875rem 1rem',
                                background: i === 0 ? 'var(--info-bg)' : 'rgba(255,255,255,0.02)',
                                border: `1px solid ${i === 0 ? 'var(--info-border)' : 'var(--panel-border)'}`,
                                borderRadius: '10px',
                                display: 'flex', alignItems: 'center', gap: '0.65rem'
                            }}>
                                <span className="material-symbols-outlined" style={{
                                    color: i === 0 ? 'var(--accent)' : 'var(--text-variant)',
                                    fontSize: '1.1rem'
                                }}>
                                    {i === 0 ? 'group' : 'person_outline'}
                                </span>
                                <span style={{ fontSize: '0.82rem', fontWeight: 600 }}>{node}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Study Groups — col 4 */}
            <div className="b-card col-4">
                <div className="card-header">
                    <h2 className="card-title">Study Groups</h2>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    {[
                        { label: 'Group Alpha', val: '24/30', pct: 80 },
                        { label: 'Group Beta', val: '18/30', pct: 60 },
                        { label: 'Group Gamma', val: '12/30', pct: 40 }
                    ].map((s, i) => (
                        <div key={i}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', marginBottom: '2px' }}>
                                <span style={{ color: 'var(--text-variant)' }}>{s.label}</span>
                                <span style={{ color: 'var(--text-highlight)', fontWeight: 700 }}>{s.val}</span>
                            </div>
                            <div className="progress-track">
                                <div className="progress-bar" style={{ width: s.pct + '%' }}></div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="link-action">
                    Manage Groups
                    <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>arrow_forward</span>
                </div>
            </div>

            {/* Student Performance — col 6 */}
            <div className="b-card col-6">
                <div className="card-header">
                    <h2 className="card-title">Student Performance</h2>
                </div>
                <div style={{ display: 'flex', gap: '2.5rem' }}>
                    <div>
                        <div style={{ fontSize: '0.7rem', color: 'var(--text-variant)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '0.3rem' }}>
                            Class Participation
                        </div>
                        <div style={{ fontSize: '2rem', fontWeight: 800, color: 'var(--text-highlight)', fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.03em' }}>92%</div>
                    </div>
                    <div>
                        <div style={{ fontSize: '0.7rem', color: 'var(--text-variant)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '0.3rem' }}>
                            Average Grades
                        </div>
                        <div style={{ fontSize: '2rem', fontWeight: 800, fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.03em' }}>88%</div>
                    </div>
                </div>
                <div style={{
                    width: '100%', height: '90px', marginTop: '2rem',
                    borderTop: '1px solid rgba(255,255,255,0.04)',
                    display: 'flex', alignItems: 'flex-end', gap: '5px', padding: '12px 0 0'
                }}>
                    {[40, 65, 55, 80, 70, 92, 88].map((h, i) => (
                        <div key={i} style={{
                            flex: 1, height: h + '%',
                            background: `rgba(var(--accent-rgb), ${0.12 + i * 0.1})`,
                            borderRadius: '4px 4px 0 0'
                        }} />
                    ))}
                </div>
            </div>

            {/* Subject Status — col 6 */}
            <div className="b-card col-6">
                <div className="card-header">
                    <h2 className="card-title">Subject Status</h2>
                    <span style={{
                        fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.8px',
                        background: 'var(--success-bg)', color: 'var(--success-text)',
                        padding: '0.3rem 0.75rem', borderRadius: '999px',
                        border: '1px solid var(--success-border)'
                    }}>On Track</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
                    {[
                        { icon: 'book', title: 'Mathematics 101', sub: 'Current Lesson: Algebra' },
                        { icon: 'biotech', title: 'Science Lab', sub: 'Ready for today' }
                    ].map((item, i) => (
                        <div key={i} style={{
                            display: 'flex', alignItems: 'center', gap: '1rem',
                            background: 'rgba(255,255,255,0.025)', padding: '1.1rem 1.25rem',
                            borderRadius: '10px', border: '1px solid var(--panel-border)'
                        }}>
                            <span className="material-symbols-outlined" style={{ color: 'var(--accent)', fontSize: '1.35rem' }}>{item.icon}</span>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '0.92rem', fontWeight: 700 }}>{item.title}</div>
                                <div style={{ fontSize: '0.78rem', color: 'var(--text-variant)', marginTop: '2px' }}>{item.sub}</div>
                            </div>
                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--accent)', boxShadow: '0 0 8px var(--accent-glow)', flexShrink: 0 }}></div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Quick Updates — col 12 */}
            <div className="b-card col-12" style={{
                background: 'var(--info-bg)', border: '1px solid var(--info-border)',
                flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '2rem'
            }}>
                <div style={{ maxWidth: '38rem' }}>
                    <h2 className="card-title" style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>Quick Updates</h2>
                    <p style={{ color: 'var(--text-variant)', fontSize: '1rem', lineHeight: 1.65 }}>
                        Get instant notifications about school holidays, schedule changes, and student reports. Always stay updated.
                    </p>
                </div>
                <div className="hero-actions" style={{ marginTop: 0, flexShrink: 0 }}>
                    <button className="btn btn-secondary" onClick={() => onNavigate('instructions')}>Read More</button>
                    <button className="btn btn-primary" onClick={() => onNavigate('login')}>Check Now</button>
                </div>
            </div>

        </section>
    </div>
);

/* ─────────────────────────────────────────────
   ADMIN VIEW
───────────────────────────────────────────── */
const AdminView = ({ onNavigate }) => (
    <div className="slide-up">
        <section className="hero">
            <div className="hero-left">
                <span className="eyebrow">
                    Admin Dashboard
                </span>
                <h1 className="hero-title">Manage Your<br />School Easily.</h1>
                <p className="hero-text">
                    Total control over your institution. Monitor attendance across all classes,
                    manage staff records, and keep track of school finances in one dashboard.
                </p>
                <div className="hero-actions">
                    <button className="btn btn-primary" onClick={() => onNavigate('login')}>Admin Login</button>
                    <button className="btn btn-secondary" onClick={() => onNavigate('register')}>Register School</button>
                </div>
            </div>
            <div className="hero-right">
                <div className="stat-card">
                    <span className="stat-label">Total Attendance</span>
                    <span className="stat-value">95%</span>
                    <div className="progress-track">
                        <div className="progress-bar" style={{ width: '95%' }}></div>
                    </div>
                </div>
                <div className="stat-card">
                    <span className="stat-label">Teachers Present</span>
                    <span className="stat-value">42</span>
                    <div className="progress-track">
                        <div className="progress-bar" style={{ width: '80%' }}></div>
                    </div>
                </div>
            </div>
        </section>

        <section className="bento-grid">

            {/* School Overview — col 8 */}
            <div className="b-card col-8">
                <div className="card-header">
                    <div>
                        <h2 className="card-title">School Overview</h2>
                        <p className="card-subtitle">Monitor campus activity and class status</p>
                    </div>
                </div>
                <div style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3rem' }}>
                    {['Main Gate', 'Block A', 'Block B', 'Block C'].map((n, i) => (
                        <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.875rem' }}>
                            <div style={{
                                width: '56px', height: '56px', borderRadius: '12px',
                                background: i === 0 ? 'var(--info-bg)' : 'rgba(255,255,255,0.025)',
                                border: `1px solid ${i === 0 ? 'var(--accent)' : 'var(--panel-border)'}`,
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                <span className="material-symbols-outlined" style={{ color: i === 0 ? 'var(--accent)' : 'var(--text-variant)', fontSize: '1.3rem' }}>
                                    {i === 0 ? 'home' : 'apartment'}
                                </span>
                            </div>
                            <span style={{ fontSize: '0.75rem', fontWeight: 600, color: i === 0 ? 'var(--text-primary)' : 'var(--text-variant)' }}>{n}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Teacher Management — col 4 */}
            <div className="b-card col-4">
                <div className="card-header">
                    <h2 className="card-title">Teacher Stats</h2>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    {[
                        { label: 'Verified Teachers', pct: 92 },
                        { label: 'Attendance', pct: 98 },
                        { label: 'Performance', pct: 84 }
                    ].map((s, i) => (
                        <div key={i}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.83rem', marginBottom: '2px' }}>
                                <span style={{ color: 'var(--text-variant)' }}>{s.label}</span>
                                <span style={{ color: 'var(--text-highlight)', fontWeight: 700 }}>{s.pct}%</span>
                            </div>
                            <div className="progress-track">
                                <div className="progress-bar" style={{ width: s.pct + '%' }}></div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="link-action">
                    View Full Staff List
                    <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>arrow_forward</span>
                </div>
            </div>

            {/* Recent Updates — col 12 */}
            <div className="b-card col-12">
                <div className="card-header">
                    <h2 className="card-title">Recent Updates</h2>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.875rem' }}>
                    {[
                        { icon: 'person_add', title: 'New Admissions', sub: '12 new students joined this week' },
                        { icon: 'grade', title: 'Exam Results', sub: 'Term 1 results have been published' },
                        { icon: 'event_busy', title: 'Holiday Notice', sub: 'School closed on Friday' },
                        { icon: 'groups', title: 'Staff Meeting', sub: 'General assembly at 10 AM' }
                    ].map((item, i) => (
                        <div key={i} style={{
                            display: 'flex', alignItems: 'center', gap: '1rem',
                            background: 'rgba(255,255,255,0.025)', padding: '1.1rem 1.25rem',
                            borderRadius: '10px', border: '1px solid var(--panel-border)'
                        }}>
                            <span className="material-symbols-outlined" style={{ color: 'var(--accent)', fontSize: '1.25rem' }}>{item.icon}</span>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '0.9rem', fontWeight: 700 }}>{item.title}</div>
                                <div style={{ fontSize: '0.78rem', color: 'var(--text-variant)', marginTop: '2px' }}>{item.sub}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </section>
    </div>
);

export default LandingPage;